
import { propsInstance } from "@/lib/util";
import { Component, MixedVue, mixins } from "@/vue";
import { VNode } from "vue";
import { Watch } from "vue-property-decorator";

interface CustomDateInputProps {
  value?: string;
  min?: string;
  max?: string;
  defaultDate?: string;
  disabled?: boolean;
}

const Props = propsInstance<CustomDateInputProps>({
  value: { type: String, required: false, default: null },
  min: {
    type: String,
    required: false,
    default: null,
  },
  max: {
    type: String,
    required: false,
    default: null,
  },
  defaultDate: {
    type: String,
    required: false,
    default: null,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
});

@Component({
  name: "CustomDateInput",
})
export default class CustomDateInput extends mixins(MixedVue, Props) {
  $refs: {
    input: HTMLInputElement;
  };

  $scopedSlots: {
    placeholder: (bindings: { value: string }) => VNode[];
  };

  get defaultPlaceholder() {
    if (!this.value) return this.$gettext("Select a date...");
    const date = new Date(this.value);
    return date.toLocaleDateString(this.$language.current, {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  }

  @Watch("disabled")
  disabledChanged(to: boolean) {
    if (to) {
      this.$refs.input.value = null;
      this.$emit("input", null);
    }
  }

  onChange(event: InputEvent) {
    this.$emit("input", (event.target as HTMLInputElement).value || null);
  }

  openInput() {
    this.$refs.input.click();
  }

  onClick() {
    (this.$refs.input as any).showPicker();
    if (this.defaultDate && !this.value) {
      this.$refs.input.value = this.defaultDate;
    }
  }
}
